import React from "react";
import {InputLabel} from "@/components/inputs";
import {Button} from "@/components/buttons";
import Timer from "./utils/timer";
import {ButtonProps, PropsInput} from "@/components/props";
import {observer} from "mobx-react-lite";
import {useEnterKeydown, useFormikConfig, useSubmitting} from "@/pages/login/hooks";
import {ICodeEmail} from "@/types/auth";
import {CodeEmail} from "@/models/auth";
import {useStore} from "@/store";
import {onSubmitCodeEmail, onSubmitRenewCodeEmail} from "@/pages/login/submits";

export const FormCode = observer(() => {
    const {formActiveStore: {setFormActive}} = useStore()
    const [isFocus, setIsFocus] = React.useState<boolean>(false);

    const onSubmit = ():void =>onSubmitCodeEmail(formik, setFormActive);
    const newCode = ():void => onSubmitRenewCodeEmail()

    const initialValues: ICodeEmail = new CodeEmail();
    const validationSchema = (initialValues as CodeEmail).validationSchema();
    const formik = useFormikConfig<ICodeEmail>(initialValues, onSubmit, validationSchema);
    useSubmitting(formik);
    useEnterKeydown(isFocus, onSubmit, setIsFocus);

    const codeProps: PropsInput = {
        name: 'code',
        label: 'Код из email',
        error: formik.touched.code && formik.errors.code,
        placeholder: 'Введите код',
        value: formik.values.code,
        type: 'text',
        colorError: 'red',
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        autoComplete: 'off',
        onFocus: () => setIsFocus(true)
    }
    const buttonProps: ButtonProps = {
        type: 'submit',
        disabled: !formik.isValid || formik.isSubmitting,

    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <Timer
                seconds={5}
                text={'Получить новый код через '}
                onClick={() => newCode()}

            />

            <InputLabel {...codeProps}/>
            <Button {...buttonProps}> Продолжить</Button>
        </form>
    )
})

export default FormCode;
